import Vue from 'vue';

export function hasUserRight(user, right) {
    if (!user) return false;

    // Super admins with GlobalAccess have all rights
    if (checkRight(user, 'GlobalAccess')) {
        return true;
    }

    return checkRight(user, right);
}

function checkRight(user, right) {
    // Check user's direct rights
    if (user.rights && user.rights.includes(right)) {
        return true;
    }

    // Check user's role rights
    if (user.role && user.role.rights && user.role.rights.includes(right)) {
        return true;
    }
    
    return false;
}

export function isTenantAdmin(user) {
    if (!user) return false;

    // TenantAdmin = ManageTenant or ManageTenantUsers but NOT GlobalAccess
    const hasManageTenant = checkRight(user, 'ManageTenant') || checkRight(user, 'ManageTenantUsers');
    const hasGlobal = checkRight(user, 'GlobalAccess');

    return hasManageTenant && !hasGlobal;
}

export function hasValidLicense(user) {
    if (!user) return false;

    // Super admins (GlobalAccess) bypass license checks
    if (hasUserRight(user, 'GlobalAccess')) {
        return true;
    }

    // Use the backend-validated license status stored in Vue prototype
    return Vue.prototype.$hasValidLicense === true;
}
